/**
 * Class for feature detection in the browser, and other browser utility functions.
 *
 * NOTE: If you want to test something in the user agent, do it through UserAgentSupport.ts.
 * But please default to using feature detection here, it it's possible.
 */
export module BrowserSupport {
  let scrollbarWidth: number;

  export function supportsFormData() {
    return (<any>window)['FormData'] !== undefined;
  }

  export function supportsFileReader() {
    return (<any>window)['FileReader'] !== undefined;
  }

  export function supportsDragAndDropEvents() {
    const div = document.createElement('div');
    return ('ondragstart' in div && 'ondrop' in div);
  }

  export function supportsSvgElements(): boolean {
    return !!('createElementNS' in document &&
    (<SVGSVGElement>document.createElementNS('http://www.w3.org/2000/svg', 'svg')).createSVGRect);
  }

  export function getScrollbarWidth(): number {
    if (typeof scrollbarWidth !== 'number') {
      const div = document.createElement('div');
      div.style.visibility = 'hidden';
      div.style.position = 'absolute';
      div.style.width = '100px';
      div.style.height = '100px';
      div.style.overflow = 'scroll';
      document.body.appendChild(div);

      const noScrollbarWidth = div.clientWidth;
      const withScrollbarWidth = div.offsetWidth;

      div.parentNode.removeChild(div);
      scrollbarWidth = withScrollbarWidth - noScrollbarWidth;
    }
    return scrollbarWidth;
  }
}
